import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=3c441816&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=3c441816&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c441816",
  null
  
)

export default component.exports